// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoCompromissos_OperadoresResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/operacao_compromissos/operadores.
 *
 * Returns the per-operador ranking of compromissos in the filter window,
 * ordered by `realizados_valor` DESC. One row per distinct
 * `compromisso_operador_user_id`.
 */
import type { OperacaoCompromissos_OperadorRow } from './OperacaoCompromissos_OperadorRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OperacaoCompromissos_OperadoresResponseDados = OperacaoCompromissos_OperadorRow[];

export type OperacaoCompromissos_OperadoresResponse = ApiResponse<OperacaoCompromissos_OperadoresResponseDados>;

registerResponseContract('OperacaoCompromissos_OperadoresResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      operador_user_id: { type: 'string',  required: true },
      operador_nome:    { type: 'string',  required: false },
      realizados_qtd:   { type: 'number',  required: false },
      realizados_valor: { type: 'number',  required: false },
      agendados_qtd:    { type: 'number',  required: false },
      cancelados_qtd:   { type: 'number',  required: false },
    },
  },
})
